global.$ = global.jQuery = require('jquery');
require('jquery-visible');
require('slick-carousel');
import PerfectScrollbar from 'perfect-scrollbar';

const menu = document.querySelector('#menu');
const ps = new PerfectScrollbar(menu);

const modalElement =  document.getElementById('modal_container');
if (typeof(modalElement) != 'undefined' && modalElement != null)
{
    const psp = new PerfectScrollbar(modalElement);
}

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();

$(document).ready(function () {

    $(".cw-select").select2();

    const $menu = $('#menu');
    const $menuToggle = $('#menuToggle');

    $(document).mouseup(function (e) {

        if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && !$menuToggle.is(e.target) &&
            $menuToggle.has(e.target).length === 0) {
            $menu.removeClass('menu_open').addClass('menu_close')
            $menuToggle.removeClass('close_burger').addClass('open_burger');
        }
    });

    $menuToggle.on('click', () => {
        if ($menuToggle.hasClass('open_burger')) {
            $menuToggle.removeClass('open_burger').addClass('close_burger');
            $menu.removeClass('menu_close').addClass('menu_open');
        } else if ($menuToggle.hasClass('close_burger')) {
            $menu.removeClass('menu_open').addClass('menu_close')
            $menuToggle.removeClass('close_burger').addClass('open_burger');
        };
    });


    // card bouton hover
    $(".card a").mouseover(function () {
        $(this).parents('.card').find('p').addClass('text_hover_color');
        $(this).parents('.card').find('h2').addClass('text_hover_color bar_hover_color');
        $(this).parents('.card').find('.titre').addClass('text_hover_color bar_hover_color');
    }).mouseout(function () {
        $(this).parents('.card').find('p').removeClass('text_hover_color');
        $(this).parents('.card').find('h2').removeClass('text_hover_color bar_hover_color');
        $(this).parents('.card').find('.titre').removeClass('text_hover_color bar_hover_color');

    });

    $('.slick').slick({
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 6000,
        nextArrow: '<div><img src="/img/icons/slider-fleche-droite.svg" class="slick_right" /></div>',
        prevArrow: '<div><img src="/img/icons/slider-fleche-gauche.svg" class="slick_left" /></div>',
    });

    $('.slick').find(".slick-slide").on("click", function () {
        $('.slick').slick("slickNext");
    });

    $('.galerie').slick({
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 6000,
        nextArrow: '<div><img src="/img/icons/slider-fleche-droite.svg" class="slick_right" /></div>',
        prevArrow: '<div><img src="/img/icons/slider-fleche-gauche.svg" class="slick_left" /></div>',
    });

    $('.galerie').find(".slick-slide").on("click", function () {
        $('.galerie').slick("slickNext");
    });

    $('#nav_galerie_1 .content_nav').addClass('current');
    $('#galerie_1').addClass('current');

    $('.item_nav_galerie').click(function () {
        var galerieId = $(this).attr('data-index');

        $('.item_nav_galerie .content_nav').removeClass('current');
        $('.galerie_item').fadeOut(300).removeClass('current');;

        $(this).find('.content_nav').addClass('current');

        setTimeout(function () {
            $("#galerie_" + galerieId).find('.galerie').slick('resize');
            $("#galerie_" + galerieId).fadeIn(400).addClass('current');
        }, 400);
    });

    var animFenouil = 0;
    var animChia = 0;
    var animAzuki = 0;
    var animAmaranthe = 0;
    var animMoutarde = 0;
    var animSarrasin = 0;
    var animEpeautre = 0;
    var animKasha = 0;

    $(window).scroll(function () {

        // Effets sur les images

        if ($('.img-anim-panorama').visible(true)) {
            $('.img-anim-panorama').css("transform", "translateY(0)");
        }
        if ($('.img-anim-bourse-commerce').visible(true)) {
            $('.img-anim-bourse-commerce').css("transform", "translateY(0)");
        }
        if ($('.img-anim-bourse-commerce-2').visible(true)) {
            $('.img-anim-bourse-commerce-2').css("transform", "translateY(0)");
        }
        if ($('.img-anim-gravure-fortier').visible(true)) {
            $('.img-anim-gravure-fortier').css("transform", "translateY(0)");
        }
        if ($('.img-anim-moutarde').visible(true)) {
            $('.img-anim-moutarde').css("transform", "translateY(0)");
        }
        if ($('.img-anim-halle-ble').visible(true)) {
            $('.img-anim-halle-ble').css("transform", "translateY(0)");
        }
        if ($('.img-anim-sarassin').visible(true)) {
            $('.img-anim-sarassin').css("transform", "translateY(0)");
        }
        if ($('.img-anim-bouteille').visible(true)) {
            $('.img-anim-bouteille').css("transform", "translateY(0)");
        }
        if ($('.img-anim-orge').visible(true)) {
            $('.img-anim-orge').css("transform", "translateY(0)");
        }
        if ($('.img-anim-bras').visible(true)) {
            $('.img-anim-bras').css("transform", "translateY(0)");
        }

        // Effets sur les mots

        if ($('.fenouil').visible(true)) {
            $('.fenouil').css("transform", "translateY(0)");
            $('.fenouil-before').css("transform", "translateY(0)");
            if (animFenouil === 0) {
                animFenouil = 1;
                FuncBoucleMotsShowFenouil();
            }
        }

        if ($('.chia').visible(true)) {
            $('.chia').css("transform", "translateY(0)");
            $('.chia-before').css("transform", "translateY(0)");
            if (animChia === 0) {
                animChia = 1;
                FuncBoucleMotsShowChia();
            }
        }

        if ($('.azuki').visible(true)) {
            $('.azuki').css("transform", "translateY(0)");
            $('.azuki-before').css("transform", "translateY(0)");
            if (animAzuki === 0) {
                animAzuki = 1;
                FuncBoucleMotsShowAzuki();
            }
        }

        if ($('.amaranthe').visible(true)) {
            $('.amaranthe').css("transform", "translateY(0)");
            $('.amaranthe-before').css("transform", "translateY(0)");
            if (animAmaranthe === 0) {
                animAmaranthe = 1;
                FuncBoucleMotsShowAmaranthe();
            }
        }

        if ($('.moutarde').visible(true)) {
            $('.moutarde').css("transform", "translateY(0)");
            $('.moutarde-before').css("transform", "translateY(0)");
            if (animMoutarde === 0) {
                animMoutarde = 1;
                FuncBoucleMotsShowMoutarde();
            }
        }

        if ($('.sarrasin').visible(true)) {
            $('.sarrasin').css("transform", "translateY(0)");
            $('.sarrasin-before').css("transform", "translateY(0)");
            if (animSarrasin === 0) {
                animSarrasin = 1;
                FuncBoucleMotsShowSarrasin();
            }
        }

        if ($('.epeautre').visible(true)) {
            $('.epeautre').css("transform", "translateY(0)");
            $('.epeautre-before').css("transform", "translateY(0)");
            if (animEpeautre === 0) {
                animEpeautre = 1;
                FuncBoucleMotsShowEpeautre();
            }
        }

        if ($('.kasha').visible(true)) {
            $('.kasha').css("transform", "translateY(0)");
            $('.kasha-before').css("transform", "translateY(0)");
            if (animKasha === 0) {
                animKasha = 1;
                FuncBoucleMotsShowKasha();
            }
        }

    });


    function FuncBoucleMotsShowFenouil() {
        if (animFenouil == 1) {
            $('.fenouil').css('opacity', '0');
            $('.fenouil-before').css('opacity', '1');

            var BoucleMotsShowFenouil = setInterval(boucleMotsShowFenouil, 5000);
        }
    }

    function boucleMotsShowFenouil() {
        if ($('.fenouil').css('opacity') == 0) {
            $('.fenouil').css('opacity', '1');
            $('.fenouil-before').css('opacity', '0');

        } else {
            $('.fenouil').css('opacity', '0');
            $('.fenouil-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowChia() {
        if (animChia == 1) {
            $('.chia').css('opacity', '0');
            $('.chia-before').css('opacity', '1');

            var BoucleMotsShowChia = setInterval(boucleMotsShowChia, 5000);
        }
    }

    function boucleMotsShowChia() {
        if ($('.chia').css('opacity') == 0) {
            $('.chia').css('opacity', '1');
            $('.chia-before').css('opacity', '0');

        } else {
            $('.chia').css('opacity', '0');
            $('.chia-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowAzuki() {
        if (animAzuki == 1) {
            $('.azuki').css('opacity', '0');
            $('.azuki-before').css('opacity', '1');

            var BoucleMotsShowAzuki = setInterval(boucleMotsShowAzuki, 5000);
        }
    }

    function boucleMotsShowAzuki() {
        if ($('.azuki').css('opacity') == 0) {
            $('.azuki').css('opacity', '1');
            $('.azuki-before').css('opacity', '0');

        } else {
            $('.azuki').css('opacity', '0');
            $('.azuki-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowAmaranthe() {
        if (animAmaranthe == 1) {
            $('.amaranthe').css('opacity', '0');
            $('.amaranthe-before').css('opacity', '1');

            var BoucleMotsShowAmaranthe = setInterval(boucleMotsShowAmaranthe, 5000);
        }
    }

    function boucleMotsShowAmaranthe() {
        if ($('.amaranthe').css('opacity') == 0) {
            $('.amaranthe').css('opacity', '1');
            $('.amaranthe-before').css('opacity', '0');

        } else {
            $('.amaranthe').css('opacity', '0');
            $('.amaranthe-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowMoutarde() {
        if (animMoutarde == 1) {
            $('.moutarde').css('opacity', '0');
            $('.moutarde-before').css('opacity', '1');

            var BoucleMotsShowMoutarde = setInterval(boucleMotsShowMoutarde, 5000);
        }
    }

    function boucleMotsShowMoutarde() {
        if ($('.moutarde').css('opacity') == 0) {
            $('.moutarde').css('opacity', '1');
            $('.moutarde-before').css('opacity', '0');

        } else {
            $('.moutarde').css('opacity', '0');
            $('.moutarde-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowSarrasin() {
        if (animSarrasin == 1) {
            $('.sarrasin').css('opacity', '0');
            $('.sarrasin-before').css('opacity', '1');

            var BoucleMotsShowSarrasin = setInterval(boucleMotsShowSarrasin, 5000);
        }
    }

    function boucleMotsShowSarrasin() {
        if ($('.sarrasin').css('opacity') == 0) {
            $('.sarrasin').css('opacity', '1');
            $('.sarrasin-before').css('opacity', '0');

        } else {
            $('.sarrasin').css('opacity', '0');
            $('.sarrasin-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowEpeautre() {
        if (animEpeautre == 1) {
            $('.epeautre').css('opacity', '0');
            $('.epeautre-before').css('opacity', '1');

            var BoucleMotsShowEpeautre = setInterval(boucleMotsShowEpeautre, 5000);
        }
    }

    function boucleMotsShowEpeautre() {
        if ($('.epeautre').css('opacity') == 0) {
            $('.epeautre').css('opacity', '1');
            $('.epeautre-before').css('opacity', '0');

        } else {
            $('.epeautre').css('opacity', '0');
            $('.epeautre-before').css('opacity', '1');
        }
    }

    function FuncBoucleMotsShowKasha() {
        if (animKasha == 1) {
            $('.kasha').css('opacity', '0');
            $('.kasha-before').css('opacity', '1');

            var BoucleMotsShowKasha = setInterval(boucleMotsShowKasha, 5000);
        }
    }

    function boucleMotsShowKasha() {
        if ($('.kasha').css('opacity') == 0) {
            $('.kasha').css('opacity', '1');
            $('.kasha-before').css('opacity', '0');

        } else {
            $('.kasha').css('opacity', '0');
            $('.kasha-before').css('opacity', '1');
        }
    };

    var numberSpinner = (function () {
        $('.number-spinner>.ns-btn').click(function () {
            var btn = $(this),
                input = btn.closest('.number-spinner').find('input'),
                oldValue = parseInt(input.val().trim()),
                newVal = 0;

            if (btn.attr('data-dir') === 'up') {
                var max = parseInt(input.attr('max'));
                newVal = (max <= oldValue ? max : oldValue + 50);
            } else {
                var min = parseInt(input.attr('min'));
                newVal = (min >= oldValue ? min : oldValue - 50);
            }
            btn.closest('.number-spinner').find('input').val(newVal);
        });
        $('.number-spinner>input').blur(function (evt) {
            var val = parseInt($(this).val().trim());
            var max = parseInt($(this).attr('max'));
            var min = parseInt($(this).attr('min'));

            if (isNaN(val)) {
                $(this).val(min);
            } else {
                if (val > max) {
                    $(this).val(max);
                } else {
                    if (val < min) {
                        $(this).val(min);
                    }
                }
            }
        });
        $('.number-spinner>input').keypress(function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        });
    })();

    $('.check_invoice').change(function () {
        if ($(this).prop('checked')) {
            $('#delivery_adress').show()
        } else {
            $('#delivery_adress').hide()
        }
    });

});


// notifications

setTimeout(function () {
    $('.notification_box').fadeOut();
}, 4000);

$('.close_notification').click(function () {
    $('.notification_box').fadeOut();
});




